import { Wrapper } from './CourseStepTab.styles';
import { SubMenuTab } from './SubMenuTab';

import { ECourseContentStep } from '@/types';

export type ISubMenuItem = {
  key: ECourseContentStep;
  label: string;
};

type Props = {
  onClick: () => void;
  isActive: boolean;
  label: string;
  subMenuItems?: ISubMenuItem[];
};

export const CourseStepTab: React.FC<Props> = ({ onClick, isActive, label, subMenuItems }) => {
  if (subMenuItems)
    return (
      <SubMenuTab label={label} subMenuItems={subMenuItems} isActive={isActive} onClick={onClick} />
    );

  return (
    <Wrapper key={label} $isActive={isActive} onClick={onClick}>
      <span>{label}</span>
    </Wrapper>
  );
};
